import { render } from "./BlockSummary.vue?vue&type=template&id=d6739706"
import script from "./BlockSummary.vue?vue&type=script&lang=js"
export * from "./BlockSummary.vue?vue&type=script&lang=js"
script.render = render

export default script